/**
 * Module management functions
 */

window.MODULES = {}; // {id: module}
window.MODULE_NAMES = {}; // {moduleName: [modules]}

let t = {
    /**
     * Initializes all modules found in a container
     * Searches for data-module atrributed elements
     * @param {*} $el The conteiner to search for modules
     */
    init ($el) {
        ($el || Z.$html).find('[data-module]').each((i, el) => {
            $(el).data('module').split(/[\s,]+/).forEach(name => t.createModule(name, el));
        });
        for (let id in MODULES) MODULES[id].afterInit();
    },

    /**
     * Creates a module on an elemant
     * @param {*} name The class name of the module
     * @param {*} el The element of the module
     * @param {*} options Extra options to pass to the module constructor
     */
    createModule (name, el, options = {}) {
        if (APP_MODULES[name]) {
            let id = Z.getID(),
                module = new APP_MODULES[name]({ el, id, name }, options);
            MODULES[id] = module;
            if (!MODULE_NAMES[name]) MODULE_NAMES[name] = [];
            MODULE_NAMES[name].push(module);
            return module;
        } else {
            console.error('Module "' + name + '" not registered');
        }
    },

    /**
     * Gets a refference to a module
     * @param {*} name Class name of the module
     * @param {*} $el Jquery element where the module resides
     */
    getByNameEl: (name, $el) => MODULES[$el.data(Z.decamelize(name))],

    /**
     * Destroy all registered modules
     */
    destroy ($container) {
        let module;
        if ($container) {
            for (let id in MODULES) {
                module = MODULES[id];
                if ($container.has(module.el).length) {
                    t.destroyModule(module);
                }
            }
        } else {
            for (let id in MODULES) t.destroyModule(MODULES[id]);
        }
    },

    destroyModule (module) {
        delete MODULES[module.id];
        let i = 0, md, modules = MODULE_NAMES[module.name];
        for (i = 0; i < modules.length && md !== module; i++) md = modules[i];
        if (md === module) modules.splice(i - 1, 1);
        module.destroy();
    },

    /**
     * Check if a module type exists
     * @param {*} name Class name of the module
     */
    exists: name => MODULE_NAMES[name] && MODULE_NAMES[name].length,
};

window.MODULE = t;

